import { COLOR } from '@src/styles/color';

export const variantMapping = {
  base: {
    size: 24,
    color: COLOR.indigo[80],
  },
};
